import { ComingSoonPage } from './ComingSoonPage';

export default function HomeAdvisoryAI() {
  return (
    <ComingSoonPage
      title="Home Advisory AI"
      description="Personalized AI guidance for buying, selling, renting and investing in Ethiopian real estate."
      canonical="https://ethiorealestates.com/home-advisory-ai"
      tagline="Your personal AI advisor for every real estate decision — launching soon."
    />
  );
}
